<div class="tab-content">
	<div class="px-5 py-4">
		<form #saveSiteTruckUtilizationSettings="ngForm" (ngSubmit)="saveTruckUtilizationSettings()" [validate-form]="'truck_utilization_settings'">
			<div class="tab-pane fade show active" id="truck_utilization">
				<div class="row mb-4">
					<label for="min_daily_truck_operating_minutes" class="col-4 font-weight-bold">{{'site_utilization_settings.min_daily_truck_operating_minutes' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field"
							type="number"
							[step]="truckStepValues.min_daily_truck_operating_minutes"
							min="0"
							name="min_daily_truck_operating_minutes"
							[(ngModel)]="truckUtilizationSettings.min_daily_truck_operating_minutes"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.minutes" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="min_truck_utilization" class="col-4 font-weight-bold">{{'site_utilization_settings.min_truck_utilization' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="truckStepValues.min_truck_utilization"
							min="0"
							max="100"
							name="min_truck_utilization"
							[(ngModel)]="truckUtilizationSettings.min_truck_utilization"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.percentage_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="min_truck_energy_utilization" class="col-4 font-weight-bold">{{'site_utilization_settings.min_truck_energy_utilization' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="truckStepValues.min_truck_energy_utilization"
							min="0"
							max="100"
							name="min_truck_energy_utilization"
							[(ngModel)]="truckUtilizationSettings.min_truck_energy_utilization"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.percentage_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="deep_in_use_end_voltage_limit" class="col-4 font-weight-bold">{{'site_utilization_settings.deep_in_use_end_voltage_limit' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="truckStepValues.deep_in_use_end_voltage_limit"
							min="1"
							name="deep_in_use_end_voltage_limit"
							[(ngModel)]="truckUtilizationSettings.deep_in_use_end_voltage_limit"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.vpc_unit" | translate}}</span></span>
					</div>
				</div> 
				<div class="row mb-4">
					<label for="num_of_deep_in_use_cycles" class="col-4 font-weight-bold">{{'site_utilization_settings.num_of_deep_in_use_cycles' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="truckStepValues.num_of_deep_in_use_cycles"
							min="1"
							name="num_of_deep_in_use_cycles"
							[(ngModel)]="truckUtilizationSettings.num_of_deep_in_use_cycles"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.cycles" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="low_in_use_end_voltage_limit" class="col-4 font-weight-bold">{{'site_utilization_settings.low_in_use_end_voltage_limit' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="truckStepValues.low_in_use_end_voltage_limit"
							min="1"
							name="low_in_use_end_voltage_limit"
							[(ngModel)]="truckUtilizationSettings.low_in_use_end_voltage_limit"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.vpc_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="num_of_low_in_use_cycles" class="col-4 font-weight-bold">{{'site_utilization_settings.num_of_low_in_use_cycles' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="truckStepValues.num_of_low_in_use_cycles"
							min="1"
							name="num_of_low_in_use_cycles"
							[(ngModel)]="truckUtilizationSettings.num_of_low_in_use_cycles"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.cycles" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="geofence_distance" class="col-4 font-weight-bold">{{'site_utilization_settings.geofence_distance' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="truckStepValues.geofence_distance"
							min="0"
							name="geofence_distance"
							[(ngModel)]="truckUtilizationSettings.geofence_distance"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.ft_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="site_operating_work" class="col-4 font-weight-bold">{{'site_utilization_settings.site_operating_work' | translate}}</label>
					<div class="col-8 d-flex">
						<div class="form-check form-check-inline" *ngFor="let day of workingDays; let dayIndex = index;">
							<input type="checkbox" class="form-check-input input-field"
								[value]="day.id"
								[id]="'workingDay-' + dayIndex"
								[checked]="isChecked(day.id)"
								(change)="onCheckboxChange(day.id, $event.target.checked)"
								name="workingDays-{{dayIndex}}"
							>
							<label class="form-check-label" [for]="'workingDay-' + dayIndex">{{ day.label }}</label>
						</div>
					</div>
				</div>
				<div class="row mb-4 align-items-center">
					<label for="shift_schedule" class="col-4 font-weight-bold mb-0"> {{ 'site_settings.shift_schedule' | translate }}</label>
					<div class="col-8 d-flex align-items-center gap-3" role="group">
						<ng-container *ngFor="let option of deviceCommonService.ddLists.scheduledOption">
							<div>
								<input
									type="radio"
									class="btn-check"
									name="shift_schedule"
									[id]="option.label"
									[(ngModel)]="truckUtilizationSettings.shift_schedule"
									[value]="option.value"
								/>
								<label class="px-2 mb-0" [for]="option.label"> {{ option.label }} </label>
							</div>
						</ng-container>
					</div>
				</div>
			</div>
			<div class="row my-4 align-items-center">
				<div class="col-md-4">
				</div>
				<div class="col-md-8">
					<div class="row align-items-center">
						<div class="col-md-8">
							<button type="submit" [disabled]="disableButton" class="btn text-white main-blue-bg btn-lg col-5 mr-4">{{'g.save' | translate}}</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>